(() => {
  if (window.szProductImages) return;
  window.szProductImages = true;
  const fitTargets = [
    ['.m-product-card__image-secondary img', 0.8],
    ['.m-product-card__image-desk > img', 0.8],
    ['.m-product-media__desktop-main .m-product-media__image', 0.78],
    ['.m-product-media__thumb-image', 0.9],
    ['.m-cart-item__image', 0.86],
  ];
  const fitSelector = fitTargets.map((t) => t[0]).join(',');
  let fitStore = {};
  try {
    fitStore = JSON.parse(localStorage.getItem('szImageFit1') || '{}');
    if (!fitStore || typeof fitStore !== 'object' || Array.isArray(fitStore)) fitStore = {};
  } catch (e) {
    fitStore = {};
  }
  let fitSaveTimer = 0;
  const saveFit = () => {
    clearTimeout(fitSaveTimer);
    fitSaveTimer = setTimeout(() => {
      try {
        const keys = Object.keys(fitStore);
        if (keys.length > 1500) keys.slice(0, keys.length - 1200).forEach((k) => delete fitStore[k]);
        localStorage.setItem('szImageFit1', JSON.stringify(fitStore));
      } catch (e) {
        
      }
    }, 1000);
  };

  const fitKey = (img) => {
    const src = img.currentSrc || img.src || '';
    try { const url = new URL(src, location.href); return url.origin + url.pathname; } catch (e) { return ''; }
  };

  let fitCanvas;
  const measure = (img) => {
    const n = 48;
    if (!fitCanvas) fitCanvas = document.createElement('canvas');
    fitCanvas.width = n;
    fitCanvas.height = n;
    const ctx = fitCanvas.getContext('2d', { willReadFrequently: true });
    if (!ctx) throw new Error('Canvas unavailable');
    
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, n, n);
    ctx.drawImage(img, 0, 0, n, n);
    const d = ctx.getImageData(0, 0, n, n).data; 
    const px = (x, y) => {
      const i = (y * n + x) * 4;
      return [d[i], d[i + 1], d[i + 2], d[i + 3]];
    };
    
    const corners = [px(0, 0), px(n - 1, 0), px(0, n - 1), px(n - 1, n - 1), px(1, 1), px(n - 2, 1), px(1, n - 2), px(n - 2, n - 2)];
    const bg = [0, 1, 2].map((c) => {
      const v = corners.map((p) => p[c]).sort((a, b) => a - b);
      return (v[3] + v[4]) / 2;
    });
    const near = (p, tol) => p[3] < 20 || Math.max(Math.abs(p[0] - bg[0]), Math.abs(p[1] - bg[1]), Math.abs(p[2] - bg[2])) <= tol;
    const share = (list) => list.filter((p) => near(p, 14)).length / list.length;
    const rows = [];
    const cols = [];
    for (let i = 0; i < n; i += 1) {
      rows.push(px(i, 0), px(i, n - 1));
      cols.push(px(0, i), px(n - 1, i));
    }
    const light = (bg[0] + bg[1] + bg[2]) / 3;
    const plainCorners = corners.filter((p) => near(p, 14)).length >= 7;
    if (light < 245 || !plainCorners || Math.max(share(rows), share(cols)) < 0.92) return { t: 'p' };
    let x0 = n, y0 = n, x1 = -1, y1 = -1;
    for (let y = 0; y < n; y += 1) {
      for (let x = 0; x < n; x += 1) {
        if (!near(px(x, y), 22)) {
          if (x < x0) x0 = x;
          if (x > x1) x1 = x;
          if (y < y0) y0 = y;
          if (y > y1) y1 = y;
        }
      }
    }
    if (x1 < 0) return { t: 'c' };
    return { t: 'c', b: [x0 / n, y0 / n, (x1 + 1) / n, (y1 + 1) / n] };
  };

  const applyFit = (img, info, target) => {
    img.classList.toggle('is-photo', info.t === 'p');
    img.classList.toggle('is-cutout', info.t === 'c');
    if (info.t !== 'c' || !info.b || !target) {
      img.style.transform = '';
      return;
    }
    
    const ratio = (img.naturalWidth || 1) / (img.naturalHeight || 1);
    const iw = ratio >= 1 ? 1 : ratio;
    const ih = ratio >= 1 ? 1 / ratio : 1;
    const ox = (1 - iw) / 2;
    const oy = (1 - ih) / 2;
    const bx0 = ox + info.b[0] * iw;
    const bx1 = ox + info.b[2] * iw;
    const by0 = oy + info.b[1] * ih;
    const by1 = oy + info.b[3] * ih;
    const w = Math.max(bx1 - bx0, 0.01);
    const h = Math.max(by1 - by0, 0.01);
    const s = Math.min(Math.max(Math.min(target / w, target / h), 0.6), 2.6);
    const cx = (bx0 + bx1) / 2;
    const cy = (by0 + by1) / 2;
    const tx = -(cx - 0.5) * s * 100;
    const ty = -(cy - 0.5) * s * 100;
    img.style.transform =
      Math.abs(s - 1) < 0.03 && Math.abs(tx) < 1 && Math.abs(ty) < 1
        ? ''
        : 'translate(' + tx.toFixed(2) + '%,' + ty.toFixed(2) + '%) scale(' + s.toFixed(3) + ')';
  };

  const fitImage = (img) => {
    if (!img.complete || !img.naturalWidth) return;
    const entry = fitTargets.find((t) => img.matches(t[0]));
    if (!entry) return;
    const key = fitKey(img);
    let info = key && fitStore[key];
    if (!info) {
      try {
        info = measure(img);
      } catch (e) {
        return; 
      }
      if (key) {
        fitStore[key] = info;
        saveFit();
      }
    }
    applyFit(img, info, entry[1]);
  };

  document.addEventListener(
    'load',
    (event) => {
      const img = event.target;
      if (img && img.tagName === 'IMG' && img.matches(fitSelector)) fitImage(img);
    },
    true
  );
  const fitAll = () => document.querySelectorAll(fitSelector).forEach(fitImage);


  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fitAll, { once: true });
  else fitAll();
})();
